module.exports = __webpack_public_path__ + "img/badge_explorer.322bd5dd.png";